export default {
    methods: {
        filterForTable(items, filterQueries, sortingOptions) {
            let filtered;

            if (filterQueries) {
                filtered = items.filter(item => {
                    for (let key in filterQueries) {
                        let value = filterQueries[key];

                        if (value === '') {
                            return true;
                        }

                        if (item[key] === null) {
                            return false;
                        }

                        if (
                            item[key] === undefined ||
                            item[key]
                                .toString()
                                .toLowerCase()
                                .indexOf(value.toString()) === -1
                        ) {
                            return false;
                        }
                    }

                    return true;
                });
            } else {
                filtered = items;
            }

            if (sortingOptions) {
                for (let attr in sortingOptions) {
                    filtered.sort((a, b) => {
                        let attrA = a[attr] ? a[attr].toLowerCase() : '';
                        let attrB = b[attr] ? b[attr].toLowerCase() : '';
                        if (attrA < attrB) return -1;
                        if (attrA > attrB) return 1;
                        return 0;
                    });
                    if (sortingOptions[attr] === 'desc') {
                        filtered.reverse();
                    }
                }
            }

            return filtered;
        },
    },
};
